import React from "react";
import HearingInstruments from './hearingInstruments'
import { withAuthorization } from "../../higher-order-components/AuthorizationHOC";
import { PageAuthorizations } from "../../../auth/pageAuthorization";

export const HearingInstrumentsTable = () => {

  return (
    <div className="container-fluid country-management" >
        <HearingInstruments />
    </div>
  )
}

export default withAuthorization(
  HearingInstrumentsTable,
  PageAuthorizations.HearingInstrumentTable.authorizedRoles
);